module.exports = __webpack_public_path__ + "static/media/research-process-bg.c427fa2c.svg";